import React, { useEffect, useRef, useState } from "react";

import { TPromptQuestion } from "chq";
import { useIsMobile } from "app/hooks";
import { t, Trans } from "app/utils";
import { Icon } from "@culturehq/components";

const INPUT_HEIGHT = 40;
const ROW_HEIGHT = 26;

type PromptQuestionProps = {
  index: number;
  question: TPromptQuestion;
  onChange: (param: Partial<TPromptQuestion>) => void;
  onNextStep: () => void;
};

const PromptQuestion: React.FC<PromptQuestionProps> = ({
  index,
  question: { id, question, instructions, answer = "" },
  onChange,
  onNextStep
}) => {
  const isMobile = useIsMobile();
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [rows, setRows] = useState(1);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      const text = inputRef.current.value.replace(/\n/g, "");
      if (text.length > 0) {
        // Set the focus at the end of the text
        const { length } = text;
        inputRef.current.setSelectionRange(length, length);
        setHeight();
      } else {
        setRows(1);
      }
    }
  }, [id]);

  const setHeight = () => {
    const currentArea = inputRef.current;
    if (currentArea && currentArea.scrollHeight > currentArea.clientHeight) {
      const newRows = Math.round((currentArea.scrollHeight - INPUT_HEIGHT) / ROW_HEIGHT);
      setRows(newRows + 1);
    }
  };

  return (
    <div className="PromptQuestion__Container">
      <div className="PromptQuestion">
        <div className="PromptQuestion__Title">
          <h2><Trans>{index}.{" "}{question}</Trans></h2>
        </div>
        <label className="chq-ffd">
          <textarea
            ref={inputRef}
            className="chq-ffd--ctrl"
            value={answer}
            onChange={e => {
              setHeight();
              onChange({ id, answer: e.target.value.replace(/\n/g, "") });
            }}
            onKeyDown={e => {
              if (e.key === "Enter" && answer.length > 0) {
                setRows(1);
                onNextStep();
              }
            }}
            placeholder={t("Type your response here...")}
            rows={rows}
          />
        </label>
        <div className="chq-sfx">
          <span className="chq-sfx-text">
            <Trans>Press <span className="chq-sfx-text__bolder">Enter</span></Trans>
          </span>
          <Icon className="chq-sfx--suffix-icon" icon="arrow-return-right" />
        </div>
      </div>
      <div className="story-information">
        <div className="story-information__container">
          <Icon icon="info-v2-filled" />
          <div>
            <Trans>{instructions}</Trans>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptQuestion;
